import { EServiceId } from '../redux/reducers';

export const PROMOTION_SERVICES = [EServiceId.top, EServiceId.premium];

// Карточка стандартного
export const STANDARD_SERVICES = [EServiceId.paid, EServiceId.free];
